<svg width="18" height="24" viewBox="0 0 18 24" xmlns="http://www.w3.org/2000/svg">
<path d="M0.0972839 0H17.927V3.456H0.0972839V0Z" />
<path d="M2.33514 16.512L0 14.208L9.02432 5.32799L18 14.232L15.6649 16.512L10.6541 11.544V24H7.34595V11.544L2.33514 16.512Z" />
</svg>
